import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/TRECUPERA_new_transparent_white.png'


const _hoisted_1 = {
  key: 0,
  class: "bg-blue_gray-800 text-white"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "flex space-x-7" }
const _hoisted_5 = {
  key: 0,
  class: "relative group"
}
const _hoisted_6 = { class: "flex items-center mt-3 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", { d: "M4 6h16M4 12h16M4 18h16" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "absolute z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600" }
const _hoisted_10 = { class: "w-full grid grid-cols-1 gap-4 text-left p-2" }
const _hoisted_11 = { class: "mt-3" }
const _hoisted_12 = { class: "grid gap-x-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    src: _imports_0,
    class: "w-40"
  })
], -1)
const _hoisted_14 = ["alt", "src"]
const _hoisted_15 = { class: "md:w-full w-96 flex flex-cols-2" }
const _hoisted_16 = {
  key: 0,
  class: "w-1/6 my-2 ml-2 lg:block hidden"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "www" }, "trecupera.com", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "lg:w-auto w-40 hidden md:flex items-center lg:space-x-3 lg:text-lg text-xs" }
const _hoisted_20 = { class: "md:hidden flex items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", { d: "M4 6h16M4 12h16M4 18h16" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "mobile-menu md:hidden"
}
const _hoisted_24 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.global.isSessionExpired())
    ? (_openBlock(), _createElementBlock("header", {
        key: 0,
        class: _normalizeClass([[
			!$setup.global.isSessionExpired()
				? 'bg-white text-black nav_sesion'
				: 'bg-gray-800 text-white',
		], "px-2 sticky top-0 z-40"])
      }, [
        (
				$setup.data_.route.fullPath !== '/' &&
				$setup.data_.route.fullPath !== '/login' &&
				$setup.data_.route.fullPath !== '/register' &&
				$setup.data_.route.fullPath !== '/recovery'
			)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.$route.name === 'Home')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                              class: "outline-none mobile-menu-button",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openMenuLeft()))
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["w-6 h-6 text-white", `hover:text-${$setup.colors.primary}-600`]),
                                "x-show": "!showMenu",
                                fill: "none",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, _hoisted_8, 2))
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-40 absolute z-10 group-hover:block text-black", [!$setup.data_.openMenuLeft_ ? 'hidden' : '']]),
                            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => ($setup.openMenuLeft())),
                            "on:mouseUpCapture": _cache[7] || (_cache[7] = ($event: any) => ($setup.openMenuLeft()))
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: "#recuperacion-facturas",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
													$setup.setHashtagMenu(
														'recuperacion-facturas'
													)
												)),
                                    class: _normalizeClass(["cursor-pointer transition duration-300", `hover:text-${$setup.colors.primary}-600`])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Reclama tu Factura")
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: "#proceso-reclamacion",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (
													$setup.setHashtagMenu(
														'proceso-reclamacion'
													)
												)),
                                    class: _normalizeClass(["cursor-pointer transition duration-300", `hover:text-${$setup.colors.primary}-600`])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("¿Cómo Funciona?")
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: "#servicios",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (
													$setup.setHashtagMenu('servicios')
												)),
                                    class: _normalizeClass(["cursor-pointer transition duration-300", `hover:text-${$setup.colors.primary}-600`])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Servicios")
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: "#opinion-clientes",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
													$setup.setHashtagMenu(
														'opinion-clientes'
													)
												)),
                                    class: _normalizeClass(["cursor-pointer transition duration-300", `hover:text-${$setup.colors.primary}-600`])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Opinión de clientes")
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: "#contacto",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (
													$setup.setHashtagMenu('contacto')
												)),
                                    class: _normalizeClass(["cursor-pointer transition duration-300", `hover:text-${$setup.colors.primary}-600`])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Contacto")
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ])
                              ])
                            ])
                          ], 34)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        class: _normalizeClass(["cursor-pointer float-left", `hover:text-${$setup.colors.primary}-600`]),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.setHashtagMenu('')))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", null, [
                              ($setup.logoTenant !== '')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    alt: $setup.logo,
                                    src: $setup.logoTenant,
                                    class: "w-40"
                                  }, null, 8, _hoisted_14))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["my-auto text-base", [
									_ctx.$route.name === 'Home' && $setup.isLocalOrDev()
										? 'w-5/6'
										: 'w-full',
								]])
                      }, [
                        _createTextVNode(" Contacta con nosotros en: "),
                        _createElementVNode("span", {
                          class: _normalizeClass(`cursor-pointer hover:text-${$setup.colors.primary}-600`),
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.mailTo && $setup.mailTo(...args)))
                        }, _toDisplayString($setup.data_.companyEmail), 3),
                        _createTextVNode(" | "),
                        _createElementVNode("span", {
                          class: _normalizeClass(`cursor-pointer hover:text-${$setup.colors.primary}-600`),
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.phoneCall && $setup.phoneCall(...args)))
                        }, _toDisplayString($setup.data_.companyPhone), 3)
                      ], 2),
                      (_ctx.$route.name === 'Home' && $setup.isLocalOrDev())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.data_.domain) = $event)),
                              class: "text-sirit_blue-500 md:w-32 w-20"
                            }, _hoisted_18, 512), [
                              [_vModelSelect, $setup.data_.domain]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: _normalizeClass(["w-40 cursor-pointer transition duration-300", `hover:text-${$setup.colors.primary}-600`])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Área clientes")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: 
								$setup.global.isSessionExpired()
									? '/register'
									: $setup.currentPath !== '/debt'
									? '/debt'
									: ''
							,
                      class: _normalizeClass(["lg:w-28 w-20 py-2 px-2 text-md font-bold text-white rounded transition duration-300", `bg-${$setup.colors.primary}-500 hover:bg-${$setup.colors.primary}-600`])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.currentPath !== "/debt"
									? "Reclama YA"
									: "siguiente"), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "outline-none mobile-menu-button",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.openMenuMobile()))
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["w-6 h-6 text-black", `hover:text-${$setup.colors.primary}-600`]),
                        "x-show": "!showMenu",
                        fill: "none",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, _hoisted_22, 2))
                    ])
                  ])
                ])
              ]),
              ($setup.data_.openMenuMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("ul", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: "/login",
                        class: _normalizeClass(["cursor-pointer block text-md px-2 py-4 text-white font-semibold", `hover:bg-${$setup.colors.primary}-600`])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Área clientes")
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_router_link, {
                        to: "/register",
                        class: _normalizeClass(["cursor-pointer block text-md px-2 py-4 text-white font-semibold", `hover:bg-${$setup.colors.primary}-600`])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Reclama ya")
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}